exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".vWEhxXuf_Ir8jTcyQ3JBd {\n  margin: 0 30px;\n}\n\n._36TB4gktzDFoNHHhwdCA3B {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: row;\n      flex-direction: row;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  -ms-flex-align: center;\n      align-items: center;\n  margin: 12px 14px;\n}\n\n.HM6hEvI1N8NnqxH2UdknP {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  width: 30px;\n}\n\n.HM6hEvI1N8NnqxH2UdknP p {\n  margin: 0;\n}\n.HM6hEvI1N8NnqxH2UdknP p:first-child {\n  font-size: 11px;\n  font-weight: 600;\n  font-family: 'proxima-nova';\n  color: silver;\n}\n.HM6hEvI1N8NnqxH2UdknP p:last-child {\n  font-size: 14px;\n  font-weight: 700;\n  font-family: 'proxima-nova';\n  color: black;\n  margin: 5px 0 0;\n}", ""]);

// exports
exports.locals = {
	"slider": "vWEhxXuf_Ir8jTcyQ3JBd",
	"sliderValues": "_36TB4gktzDFoNHHhwdCA3B",
	"sliderValue": "HM6hEvI1N8NnqxH2UdknP"
};


//////////////////
// WEBPACK FOOTER
// /Users/smotley795/Source/kardia-pro/node_modules/css-loader?{"importLoaders":1,"modules":{"localIdentName":"[name]__[local]___[hash:base64:5]"}}!/Users/smotley795/Source/kardia-pro/node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null,null]}!./src/legacy/components/Slider/Slider.css
// module id = 3864
// module chunks = 23